{
  "share_mail_label": "Compartilhar usando correio eletrônico",
  "error": "um erro ocorreu",
  "no_title": "sem título",
  "login_password": "palavra-passe",
  "login_username": "utilizador",
  "login": "entrar",
  "more": "mais",
  "no_entries": "nenhum registo encontrado",
  "source_saved": "gravado",
  "source_cancel": "cancelar",
  "source_save": "gravar",
  "source_type": "Tipo",
  "source_select": "por favor, selecione a fonte",
  "source_comma": "separado por vírgula",
  "source_tags": "Marcadores",
  "source_title": "Título",
  "source_new": "nova fonte (não salva)",
  "source_warn": "realmente deletar esta fonte?",
  "source_delete": "deletar",
  "source_filter": "Filtro",
  "source_edit": "editar",
  "source_export": "exportar fontes",
  "source_opml": "ou importar ficheiro opml ou google reader",
  "source_add": "adicionar fonte",
  "sources": "Fontes",
  "loginbutton": "entrar",
  "logoutbutton": "sair",
  "settingsbutton": "configurações",
  "refreshbutton": "atualizar fontes",
  "searchbutton": "procurar",
  "next": "próximo",
  "open_window": "abrir",
  "load_img": "carregar Imagens",
  "unmark": "marcar como não lido",
  "mark": "marcar como lido",
  "unstar": "remover estrela",
  "star": "marcar com estrela",
  "seconds": "{0,plural,one {1 segundo},other {# segundos}} atrás",
  "minutes": "{0,plural,one {1 minuto},other {# minutos}} atrás",
  "hours": "{0,plural,one {1 hora},other {# horas}} atrás",
  "timestamp": "{0,date} {0,time}",
  "alltags": "todos os marcadores",
  "tags": "Marcadores",
  "starred": "com estrela",
  "unread": "não lidos",
  "newest": "novos",
  "markread": "marcar como lido",
  "source_last_post": "Última postagem vista",
  "source_menu": "Mais ações",
  "offline_navigation_unavailable": "A troca de etiquetas e fontes não está atualmente disponível em modo offline.",
  "offline_count": "Artigos disponíveis localmente",
  "searchremove": "Ocultar busca",
  "share_diaspora_label": "Compartilhar na Diáspora",
  "share_facebook_label": "Compartilhar no Facebook",
  "share_pocket_label": "Salvar no Pocket",
  "share_wallabag_label": "Salvar no Wallabag",
  "share_copy_label": "Copiar link para a área de transferência",
  "source_refresh": "Atualizar esta fonte",
  "share_native_label": "Compartilhar",
  "search_label": "Termo de pesquisa",
  "sources_leaving_unsaved_prompt": "Deixar configurações com alterações de fonte não salvas?",
  "online_count": "Itens disponíveis no servidor",
  "share_wordpress_label": "Compartilhar no WordPress",
  "source_autotitle_hint": "Deixe vazio para buscar título",
  "source_browse": "Navegar",
  "source_warn_cancel_dirty": "Descartar alterações não salvas?",
  "filter": "Filtro",
  "share_twitter_label": "Compartilhe no Twitter",
  "tag_change_color_button_title": "Alterar a cor",
  "sources_loading": "Carregando fontes…",
  "no_sources": "Nenhuma fonte configurada.",
  "source_deleting": "Excluindo fonte…",
  "source_pwd_placeholder": "Não alterado",
  "source_params_loading": "Carregando parâmetros…",
  "source_saving": "Salvar mudanças de fonte…",
  "source_go_to_settings": "Abrir nas configurações",
  "entries_loading": "Carregando entradas…",
  "login_in_progress": "Tentando fazer login…"
}
